import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// PROFILE USER
const submit = (payload) => client.post('auth/profileUser', payload);
export const useCreateUser = (payload) => useMutation(['profileUser'],() => submit(payload))




const bulkProfileFn = async (file) => {
  const form = new FormData();
  form.append('file', file);
  // Controller route: [Route("api/profile")] + [HttpPost("bulk")]
  const { data } = await client.post('auth/bulk', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data; // { total, succeeded, failed, rows: [{rowNumber,login,success,message}] }
};

export const useBulkProfile = () =>
  useMutation({
    mutationFn: bulkProfileFn,
  });

export const useDownloadBulkTemplate = () => {
  // Controller route: GET api/profile/bulk/template
  return async () => {
    const { data } = await client.get('auth/bulk/template', {
      responseType: 'blob',
    });
    const blob = new Blob(
      [data],
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'bulk-profile-template.xlsx';
    a.click();
    URL.revokeObjectURL(url);
  };
};
